import { useState, useEffect, createContext } from 'react';
import { Lang } from '../types';

export const LanguageContext = createContext<{
  lang: Lang;
  setLang: (l: Lang) => void;
}>({ lang: 'es', setLang: () => {} });

export const useLanguage = () => {
  const [lang, setLangState] = useState<Lang>('es');

  useEffect(() => {
    const saved = localStorage.getItem('dc_lang') as Lang;
    if (saved && ['es', 'en', 'fr'].includes(saved)) {
      setLangState(saved);
    }
  }, []);

  const setLang = (l: Lang) => {
    setLangState(l);
    localStorage.setItem('dc_lang', l);
  };

  return { lang, setLang };
};
